export const chapters = [
  {
    id: 4,
    part: 1,
    englishTitle: "The Written Test",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: false,
    content: `Content for The Written Test...`,
 }
];